import { mapSuccess, RemoteData } from '../../reducers/remoteData';
import { SporsmalType, VerkstedWebDTO } from '../../types/generated-types';
import { toValidNumberString } from '../format';
import { CurrentSporsmal } from '../reducer/current-steg';
import { Bilmerke, Verkstedsporsmal } from '../reducer/sporsmalsflyt-types';

export interface CurrentVerkstedsporsmal {
    type: SporsmalType.Verksted;
    id: string;
    sporsmal: Verkstedsporsmal;
    postnummer: string;
    bilmerke?: Bilmerke;
    verksteder: RemoteData<Verksted[]>;
}

export interface BesvartVerkstedsporsmal {
    type: SporsmalType.Verksted;
    id: string;
    sporsmal: Verkstedsporsmal;
    postnummer: string;
    bilmerke: Bilmerke;
    verksteder: RemoteData<Verksted[]>;
}

export type Verksted = VerkstedWebDTO;

const fromVerkstedDTO = (verksteder: VerkstedWebDTO[]): Verksted[] => verksteder;

export const isVerkstedSporsmal = (currentSporsmal: CurrentSporsmal): currentSporsmal is CurrentVerkstedsporsmal =>
    currentSporsmal.type === SporsmalType.Verksted;

export const isBesvartVerkstedSporsmal = (
    currentSporsmal: CurrentVerkstedsporsmal,
): currentSporsmal is BesvartVerkstedsporsmal => !!currentSporsmal.bilmerke;

export const updateCurrentPostnummer = (currentSporsmal: CurrentSporsmal, postnummer: string): CurrentSporsmal => {
    if (isVerkstedSporsmal(currentSporsmal)) {
        return {
            ...currentSporsmal,
            postnummer: toValidNumberString(postnummer),
        };
    }
    return currentSporsmal;
};

export const updateCurrentBilmerke = (currentSporsmal: CurrentSporsmal, bilmerke?: Bilmerke): CurrentSporsmal => {
    if (isVerkstedSporsmal(currentSporsmal)) {
        return {
            ...currentSporsmal,
            bilmerke,
        };
    }
    return currentSporsmal;
};

export const updateCurrectFetchVerkstederStatus = (
    currentSporsmal: CurrentSporsmal,
    verksteder: RemoteData<VerkstedWebDTO[]>,
    postnummer: string,
    bilmerke: Bilmerke,
): CurrentSporsmal => {
    if (isVerkstedSporsmal(currentSporsmal)) {
        if (postnummer === currentSporsmal.postnummer && bilmerke === currentSporsmal.bilmerke) {
            return {
                ...currentSporsmal,
                verksteder: mapSuccess(verksteder, fromVerkstedDTO),
            };
        }
    }
    return currentSporsmal;
};

export const isValidPostnummer = (postnummer: string): boolean => !!postnummer.trim().match(/^\d{4}$/g);

export const isValidVerkstedSporsmal = (currentSporsmal: CurrentVerkstedsporsmal): boolean =>
    isValidPostnummer(currentSporsmal.postnummer) && !!currentSporsmal.bilmerke;
